/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";

function ENSExecutiveExpensesInformation() {
  return (
    <MKBox component="section" py={12}>
      <Container>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} lg={12} sx={{ ml: "auto", mt: { xs: 3, lg: 0 } }}>
            <DefaultInfoCard
              //icon="info"
              title="ENS Executive Expenses"
              description={
                <>
                  <h4>Elections Nova Scotia values accountability and transparency. Travel expenses exceeding $200 claimed by senior managers are posted here annually.</h4><br />
                  <h3>Executive Expenses</h3><br />
                  <ul style={{ paddingLeft: "40px" }}>
                    <li><a href=" /files/ENSExecutiveExpenses/ExecutiveExpensesApr2023March2024_1.pdf"> Executive Expenses from April 1, 2023 to March 31, 2024 (PDF)</a></li>
                    <li><a href=" /files/ENSExecutiveExpenses/ExecutiveExpensesApr2022March2023.pdf">Executive Expenses from April 1, 2022 to March 31, 2023 (PDF)</a></li>
                  </ul>
                </>
              }
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default ENSExecutiveExpensesInformation;
